import {
  ServerActionWidget,
  SPI,
  ActionWidget,
  ActionType,
  ClickResult,
  RuntimeServerAction,
  SubmitValue,
  ActiveRecord
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';


@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'commit',
    model: 'deli.aries.platform.fund.banks.DeliAriesBanksCreditRulesProxy'
  })
)
export class commitCreditRulesWidget extends ServerActionWidget {
 

  protected executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
    const formData = submitValue.records! as ActiveRecord;
    //@ts-ignore
    // const promotionDesignJson = JSON.parse(formData.promotionDesignJson);
    // if (testSubmitValue(promotionDesignJson)) {
      return super.executeAction(action, submitValue);
    // } else {
    //   OioNotification.error('错误', '请检查活动设计');
    //   this.__executeSuccess = false;
    //   return null as any;
    // }
  }
  protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
    return super.clickActionAfter(result);
  }
}
